/**
 * PURPOSE: Mostrar en el modal público de vóley el marcador por sets y el detalle de puntos de cada periodo.
 * RESPONSIBILITIES: Ordenar periodos, mantener una matriz compacta para celular y evitar usar la suma total de puntos como resultado del partido.
 * COLLABORATORS: ModalDetalle.jsx, Resultados.jsx, MatchDay.jsx y applyMatchSnapshot.js.
 * ROUTE: hayllis-legacy/src/components/Modal/ModalDetalle/VolleyballScoreSummary.jsx
 */

import React, { useMemo } from "react";

const scoreValue = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export default function VolleyballScoreSummary({
  periods = [],
  team1Abrev = "T1",
  team2Abrev = "T2",
}) {
  const orderedPeriods = useMemo(
    () =>
      (Array.isArray(periods) ? [...periods] : [])
        .filter((period) => Number(period?.nro_periodo) > 0)
        .sort(
          (left, right) =>
            Number(left.nro_periodo) - Number(right.nro_periodo)
        )
        .slice(0, 5),
    [periods]
  );

  if (!orderedPeriods.length) return null;

  const gridTemplateColumns = `minmax(48px, 1.25fr) repeat(${orderedPeriods.length}, minmax(34px, 1fr))`;

  return (
    <div className="mx-auto mt-3 w-full max-w-md rounded-2xl border border-gray-200 bg-white/90 p-2 shadow-sm">
      <div
        className="grid items-center gap-1 text-center"
        style={{ gridTemplateColumns }}
        aria-label="Puntaje por set"
      >
        <div className="text-left text-[10px] font-extrabold uppercase tracking-wide text-gray-400">
          Set
        </div>
        {orderedPeriods.map((period) => (
          <div
            key={`set-${period.nro_periodo}`}
            className="text-[10px] font-extrabold uppercase text-gray-500"
          >
            S{period.nro_periodo}
          </div>
        ))}

        <div className="truncate text-left text-[11px] font-black uppercase text-gray-800">
          {team1Abrev}
        </div>
        {orderedPeriods.map((period) => (
          <div
            key={`team-1-${period.nro_periodo}`}
            className="rounded-lg bg-slate-100 py-1 text-sm font-black tabular-nums text-slate-900"
          >
            {scoreValue(period.puntos1)}
          </div>
        ))}

        <div className="truncate text-left text-[11px] font-black uppercase text-gray-800">
          {team2Abrev}
        </div>
        {orderedPeriods.map((period) => (
          <div
            key={`team-2-${period.nro_periodo}`}
            className="rounded-lg bg-slate-100 py-1 text-sm font-black tabular-nums text-slate-900"
          >
            {scoreValue(period.puntos2)}
          </div>
        ))}
      </div>
    </div>
  );
}
